import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */
import { Icon, tip } from '@wordpress/icons';

/**
 * Internal dependencies
 */

export function Tip(props) {
  const {
    children
  } = props;
  return createElement("div", {
    className: "components-tip"
  }, createElement(Icon, {
    icon: tip
  }), createElement("p", null, children));
}
export default Tip;
//# sourceMappingURL=index.js.map